var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-legend"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "title": _vm.legendHelp
    }
  }, [_vm._v("Legend (?)")]), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "task",
      attrs: {
        "title": ("From " + (row.from) + " to " + (row.to))
      },
      on: {
        "click": function($event) {
          _vm.$emit('task-click', row.start)
        }
      }
    }, [_c('span', {
      staticClass: "task-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('span', {
      staticClass: "task-link"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blank"
      }
    }, [_vm._v("...")])])])
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-305456fa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GanttLegend.vue
// module id = 190
// module chunks = 1